import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { getdropdowncities } from "./api";
import Warning from "../../../src/assests/images/warning-2.svg";
import box from "../../../src/assests/images/box.svg";
import Information from "../../../src/assests/images/info-circle.svg";
import Arrowup from "../../../src/assests/images/arrow_up_download.svg";
import Fileupload from "../../components/FileuploadWithPreview/Fileupload";
import { Checkbox, ListItemText } from "@mui/material";
import ArrowDownIcon from "../../../src/assests/images/arrow-down-curve.svg";
import CSVUpload from "./CSVUpload";
type PackDetails = {
  "10's Pack MRP Amount": string;
  "20's Pack MRP Amount": string;
};

// interface FormBrandProps {
//   brandName: string;
//   // brand_availbale_locations:string
//   setBrandName: React.Dispatch<React.SetStateAction<string>>;
//   availableLocation: string;
//   setAvailableLocation: React.Dispatch<React.SetStateAction<string>>;
//   packDetails: PackDetails;
//   city?:string;
//   setPackDetails: React.Dispatch<React.SetStateAction<PackDetails>>;
// }
interface FormBrandProps {
  brandName: string;
  setBrandName: React.Dispatch<React.SetStateAction<string>>;
  availableLocation: string[];
  setAvailableLocation: React.Dispatch<React.SetStateAction<string[]>>;
  packDetails: PackDetails;
  setPackDetails: React.Dispatch<React.SetStateAction<PackDetails>>;
  city?: string;
}

function FormBrand({
  brandName,
  setBrandName,
  // brand_availbale_locations,
  availableLocation,
  setAvailableLocation,
  packDetails,
  setPackDetails,
  city
}: FormBrandProps) {



  const handleChange = (
    event: SelectChangeEvent<any> | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    console.log(value, "kkkkkkkkkkkkkkkkkk", name, "55namenamenamenamename")
    if (name === "brandName") {
      setBrandName(value as string);
    } else if (name === "availableLocation") {
      const parsedValue = Array.isArray(value)
        ? value
        : typeof value === 'string'
          ? value.split(',')
          : [];
      setAvailableLocation(parsedValue as string[]);
    } else {
      setPackDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  console.log(availableLocation, "availableLocationavailableLocationssss")
  const [dropdowncities, setdropdowncities] = useState<any[]>([]);
  console.log(city, "citycity")
  useEffect(() => {
    const fetchdropdowncities = async () => {
      try {
        const response = await getdropdowncities();

        console.log(
          JSON.stringify(response.data, null, 2),
          "citiescitiescites"
        );

        setdropdowncities(response.data.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchdropdowncities();
  }, []);
  // console.log(brand_availbale_locations, "brand_availbale_locationseeee")

  const CustomArrowIcon = (props: any) => (
    <img
      src={ArrowDownIcon}
      alt="arrow"
      {...props} // This is important!
      style={{
        width: 16,
        height: 16,
        marginRight: "12px",
        pointerEvents: "none",
        ...props.style,
      }}
    />
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: "#fff",
        padding: "20px",
      }}
    >
      {/* General Information */}
      <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={Information}
          alt="Information"
          style={{ marginRight: "8px", marginTop: "4px" }} // Adjusted margin-top for the image
        />        General Information
      </Typography>

      {/* Brand Name */}
      <Typography
        variant="subtitle2"
        sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
      >
        Brand Name*
      </Typography>
      <TextField
        placeholder="Enter brand name"
        sx={{ border: "1px solid #E7E8E9", borderRadius: "10px", "& .MuiOutlinedInput-notchedOutline": { border: "none !important" } }}
        name="brandName"
        value={brandName}
        error={!brandName}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      />

      {/* Available Location */}
      <Box sx={{ display: "flex" }}>
        <Box sx={{ width: "85%" }}>
          <Typography
            variant="subtitle2"
            sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
          >
            Available Location*
          </Typography>
          <FormControl fullWidth margin="normal">
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Select
                multiple
                displayEmpty
                name="availableLocation"
                value={availableLocation}
                onChange={handleChange}
                IconComponent={CustomArrowIcon}
                inputProps={{ "aria-label": "Available Location" }}
                sx={{
                  width: "100%",
                  border: "1px solid #E7E8E9",
                  borderRadius: "10px",
                  boxShadow: "none",
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#fff !important" },
                  "& .MuiSelect-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "1px solid #E7E8E9 !important", },

                  "& .MuiSelect-icon": {
                    top: "calc(50% - 8px)",
                    right: "12px",

                  },
                }}
                renderValue={(selected) =>
                  (selected as string[]).length === 0
                    ? <em>Select Available Locations</em>
                    : (selected as string[]).join(", ")
                }
              >
                <MenuItem disabled value="">
                  <em>Select Available Locations</em>
                </MenuItem>
                {dropdowncities.map((city: string, index: number) => (
                  <MenuItem key={index} value={city}>
                    <Checkbox checked={availableLocation.includes(city)} />
                    <ListItemText primary={city} />
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </FormControl>
        </Box>
        <Box sx={{ margin: "60px 0 0 20px" }}>
          <CSVUpload />
        </Box>
      </Box>

      {/* Pack Details */}
      <Typography
        variant="h6"
        sx={{ mt: 2, display: "flex", alignItems: "center" }}
      >
        <img
          src={box}
          alt="box"
          style={{ marginRight: "8px", marginTop: "4px" }} // Adjusted margin-top for the image
        />
        Pack Details
      </Typography>

      <Box
        sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
      >
        <Box sx={{ width: "48%" }}>
          <Typography
            variant="subtitle2"
            sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
          >
            10's Pack MRP Amount
          </Typography>
          <TextField
            error={!packDetails["10's Pack MRP Amount"] ||
              isNaN(Number(packDetails["10's Pack MRP Amount"]))}
            placeholder="Enter MRP for 10's Pack"
            name="10's Pack MRP Amount"
            value={packDetails["10's Pack MRP Amount"]}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </Box>

        <Box sx={{ width: "48%" }}>
          <Typography
            variant="subtitle2"
            sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
          >
            20's Pack MRP Amount
          </Typography>
          <TextField
            error={!packDetails["20's Pack MRP Amount"] ||
              isNaN(Number(packDetails["20's Pack MRP Amount"]))}
            placeholder="Enter MRP for 20's Pack"
            name="20's Pack MRP Amount"
            value={packDetails["20's Pack MRP Amount"]}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </Box>
      </Box>
      {/* Note */}
      <Typography
        variant="body1"
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "start",
          color: "#282829",
          fontSize: "14px",
          background: "rgba(245, 230, 150, 0.40)",
          padding: "8px 10px",
          borderRadius: "6px"
        }}
      >
        <img
          src={Warning}
          alt="warning"
          style={{ marginRight: "8px", marginTop: "4px" }} // Adjusted margin-top for the image
        />
        Note: Any extension of active task will trigger an email to project
        owner abc@pmintl.com for approval.
      </Typography>    </Box>
  );
}

export default FormBrand;
